import { render, staticRenderFns } from "./T1Header.vue?vue&type=template&id=4045a907&scoped=true&"
import script from "./T1Header.vue?vue&type=script&lang=js&"
export * from "./T1Header.vue?vue&type=script&lang=js&"
import style0 from "./T1Header.vue?vue&type=style&index=0&id=4045a907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045a907",
  null
  
)

export default component.exports